//messages.js
export default {
    truck_id: "Truck #",
    company_id: "Company Id",
    truck_name: "Truck Name",
    max_weight: "Max Weight",
    compartment1: "#1",
    compartment2: "#2",
    compartment3: "#3",
    compartment4: "#4",
    compartment5: "#5",
    num_of_compartments: "# Of Compartments",
    driver_id: "Driver",
    serial: "Serial",
    meter_style: "Meter Style",
    vehicle_type: "Vehicle Type",
    edit_tanker_truck: "Edit Tanker Truck",
    add_tanker_truck: "Add Tanker Truck",
    delete_tanker_truck: "Delete Tanker Truck",
    tanker_trucks: "Tanker Trucks",
    delete_tanker_truck_confirm: "This action is not reversible!",
    truck: "Truck",
    payload: "Payload",
    gvwr: "GVWR",
    payload_weight: "Payload Weight",
    trailer_name: "Trailer Name",
    edit_truck_or_trailer: "Edit Truck/Trailer",
    add_truck_or_trailer: "Add Truck/Trailer",
    trailer: "Trailer",
    trucks_and_trailers: "Trucks & Trailers",
};
